import { sendTrackingEvent } from '../services/service.tracking';
import { getVehicleQuestionData } from '../utils/utils.tracking';

export const trackLeadFormLoad = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'impression',
    eventResult: 'ico_contact',
    eventNonInteractive: false,
    eventData: getVehicleQuestionData(),
  });
};
